export const handleBarsParams = [
  {
    name: '{{ifFirst}}',
    description: 'checks if the iterated item is first',
  },
  {
    name: '{{ifEven}}',
    description: 'checks if the iterated item is even',
  },
  {
    name: '{{ifOdd}}',
    description: 'checks if the iterated item is odd',
  },
  {
    name: '{{ifEvenOrLast}}',
    description: 'checks if the iterated item is even or last',
  },
  {
    name: '{{ifOddOrLast}}',
    description: 'checks if the iterated item is odd or last',
  },
  {
    name: '{{formatPrice product "listPrice"}}',
    description:
      'Formats the given product price field according to the product`s currency and locale (e.g., {{formatPrice this "listPrice"}} → "1 000,00 лв.").',
  },
  {
    name: '{{formatPriceAdvanced product "listPrice" "bg-BG" 0 0}}',
    description:
      'Formats the given product price field with a specific locale and custom fraction digit settings. Parameters: product, field, locale, minimumFractionDigits, maximumFractionDigits (e.g., {{formatPriceAdvanced this "listPrice" "bg-BG" 0 0}} → "1 000 лв.").',
  },
  {
    name: '{{currencyCodeToSymbol "CurrencyCode" "locale"}}',
    description:
      'Takes currency code and locale and returns its symbol. For example {{currencyCodeToSymbol "BGN" "bg-BG"}} will return лв.',
  },
  {
    name: '{{#ifZero discount}}',
    description: 'Checks if number is zero. In the example checks if discount is zero',
  },
  {
    name: '{{addUtm url}}',
    description: 'Adds UTM tags. In the example we are adding UTM tag to a URL',
  },
  {
    name: '{{fixedNumber price}}',
    description: 'Returns whole number. In the example it will convert the price to be in the format of 1.',
  },
  {
    name: '{{math price "-" discountPrice}}',
    description:
      'Mathematical operators supported are "+", "-", "*", "/" and "%". In the example we are subtracting price from discount price',
  },
  {
    name: '{{{truncate name 45}}}',
    description: 'Truncates text to fixed length. In the example sets the name to be 45 symbols',
  },
  {
    name: '{{find custom.string "key" "categoryLabelHtml"}}',
    description: 'Searches in fields by string. In the example we are searching for a custom field categoryLabelHtml.',
  },
  {
    name: '{{toFixed listPrice 2}}',
    description:
      'Sets the length of float number. In the example we are setting the listPrice to be in the format of 01.99',
  },
  {
    name: '{{ replace (toFixed listPrice 2) "." "," }}',
    description: 'Replaces strings. In the example replaces . with ,',
  },
  {
    name: '{{ replaceAll string " " "@" }}',
    description:
      'Replaces all occurancies of an given string with a desired replacer. In the example if we have a string = "Releva rocks" the helper will find all occurancies of " "(empty string) and replace them with "@". The output will be "Relava@rocks" . with ,',
  },
  {
    name: '{{discountPercentage discountPrice price}}',
    description:
      'Calculates discount percentage. In the example takes discount price and price and calculates the discount percentage',
  },
  {
    name: '{{isGTE}}',
    description:
      'Determines if a value is greater than or equal to another value. For example, {{#isGTE A B}}foo{{/isGTE}} will print "foo" if A is greater than or equal to B',
  },
  {
    name: '{{ifEquals}}',
    description:
      'Determines if a value is strictly equal to another value. For example, {{#iifEquals A B}}foo{{/ifEquals}} will print "foo" if A is equal to B (A===B)',
  },
  {
    name: '{{ifContains}}',
    description:
      'Determines if a string contains a substring. For example, {{#ifContains foo oo}}bar{{/ifContains}} will print "bar", respectively {{#ifContains foo bar}}bar{{/ifContains}} will return "false" and print nothing',
  },
  {
    name: '{{ifDatePast}}',
    description:
      'Determines if a given date string is before today`s date. For example, today is 21st of August 2023,  {{#ifDatePast "04/04/2023"}}bar{{/ifDatePast}} will print "bar", respectively {{#ifDatePast "24/12/2023"}}bar{{/ifDatePast}} will return "false" and print nothing',
  },
  {
    name: '{{ifDateFuture}}',
    description:
      'Determines if a given date string is after today`s date. For example, today is 21st of August 2023,  {{#iifDateFuture "24/12/2023"}}bar{{/ifDateFuture}} will print "bar", respectively {{#ifDateFuture "04/04/2023"}}bar{{/ifDateFuture}} will return "false" and print nothing',
  },
  {
    name: '{{parseInt}}',
    description: 'Parses a string argument and returns an integer . For example, {{parseInt "01.23"}} will print 1',
  },
  {
    name: '{{toString 2}}',
    description: 'Parses a non-string value to a string value. In the example the output is "2"',
  },
  {
    name: '{{join}}',
    description:
      'Accepts 2 parameters - an array and a separator. Creates and returns a new string by concatenating all of the elements in the array, separated by the given separator string. For example we have an array called elements = ["Fire" , "Air", "Water"], {{join elements "*"}} will return the string "Fire*Air*Water" ',
  },
  {
    name: '{{split}}',
    description:
      'Accepts 2 parameters - a string and a separator. Creates and returns an array. For example we have a string = "Releva rocks", {{split string " "}} will return the array ["Releva", "rocks"]',
  },
  {
    name: '{{encodeURIComponent}}',
    description:
      'Encodes a URI by replacing each instance of certain characters, representing the UTF-8 encoding of the character. For example {{encodeURIComponent "test?"}} will return "test%3F"',
  },
  {
    name: '{{plusDays}}',
    description:
      'Accepts 2 parameters - a date in [YYYY]-[MM]-[DD] format and a number of days. It returns a future date by adding the specified number of days to the input date. For example {{plusDays "2023-10-31" 2}} will return "2023-11-02".',
  },
  {
    name: '{{minusDays}}',
    description:
      'Accepts 2 parameters - a date in [YYYY]-[MM]-[DD] format and a number of days. It returns a past date by subtracting the specified number of days from the input date. For example {{minusDays "2023-10-31" 2}} will return "2023-10-29".',
  },
  {
    name: '{{dateToLocaleFormat}}',
    description:
      'Accepts 2 parameters - a date in [YYYY]-[MM]-[DD] format and a locale. It returns the date in the specified locale format. For example {{dateToLocaleFormat "2023-10-31" "it-IT"}} will return "31-10-2023".',
  },
  {
    name: '{{toLowerCase}}',
    description:
      'Accepts 1 paramet - string. It returns the string in lower case. For example {{toLowerCase "Releva Rocks"}}  will be returned as "releva rocks".',
  },
  {
    name: '{{toUpperCase}}',
    description:
      'Accepts 1 paramet - string. It returns the string in upper case. For example {{toUpperCase "Releva Rocks"}}  will be returned as "RELEVA ROCKS".',
  },
  {
    name: '{{isNthElement}}',
    description:
      '{{#each items}}{{#if (isNthElement 3)}} This block will be executed for every third element {{/if}}{{/each}}',
  },
  {
    name: '{{convertToEuro}}',
    description:
      '{{convertToEuro price}} Converts a given amount in Bulgarian lev (BGN) to euros (EUR) using the fixed conversion rate of 1.95583. The value is divided by the full official exchange rate and rounded to two decimal places according to Bulgarian law. Example: {{convertToEuro 1000}} outputs 511.29',
  },
  {
    name: '{{convertToBgn}}',
    description:
      '{{convertToBgn price, currency}} Converts a given amount from EUR or BGN to Bulgarian lev (BGN) using the fixed official exchange rate 1 EUR = 1.95583 BGN. If the currency is EUR, the value is multiplied by 1.95583 and rounded to two decimal places. If the currency is BGN, the helper returns the original amount. If any other currency is provided, the helper returns an empty string.',
  },
  {
    name: '{{now}}',
    description: 'Inserts the current date and time in ISO format (e.g., 2025-11-03T14:30:00.000Z)',
  },
  {
    name: '{{currentYear}}',
    description: 'Inserts the current year as a four-digit number (e.g., 2025)',
  },
];
